<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <poolsidebar></poolsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <div class="moduleCard">
            <div class="text-right">
              <a href="javascript:void(0)" @click="goBack"><font-awesome-icon icon="arrow-left" role="presentation"></font-awesome-icon><span id="go_back"> Go Back</span></a>
            </div>            
            <div class="row mt-2">
              <div class="col-12">
                <input id="search" type="text" v-model="search" placeholder="Search..." style="width:50%;" />
              </div>
            </div>
            <div class="row mt-2" v-show="IsAdmin===true">
              <div class="col-4">
                <input type="text" v-model="newTag" class="fullWidth" />
              </div>
              <div class="col-2">
                <button class="btn btn-secondary btn-short" @click="addTag" id="add">Add</button>
              </div>
              <div class="col-6">
                &nbsp;
              </div>
            </div>
            <div v-if="possibleTags!==null">
              <h2 class="mb-4" id="license_pool_tags">License Pool Tags</h2>
              <div class="row mt-2" v-for="possibletag in filteredList()" :key="possibletag.TagName">
                <div class="col-4">
                  {{possibletag.TagName}}
                </div>
                <div class="col-2">
                  <button v-show="IsAdmin===true" class="btn-transparent" @click="openPopup(possibletag.LicensePoolTagID, possibletag.TagName)"><font-awesome-icon icon="edit" aria-label="edit"></font-awesome-icon></button>
                  <button v-show="IsAdmin===true" class="btn-transparent" @click="removeTag(possibletag.LicensePoolTagID)"><font-awesome-icon icon="times" aria-label="Remove"></font-awesome-icon></button>
                </div>
                <div class="col-6">&nbsp;</div>
              </div>
              <div class="row mt-2" v-show="possibleTags.length===0">
                <div class="col-12" id="no_tags">
                  There are no tags
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal ref="editorModel" hide-footer title="Edit Tag" id="edit_tag">
        <div class="row mt-2">
          <div class="col-8">
            <input type="text" v-model="editTag" class="fullWidth" />
          </div>
          <div class="col-2">
            <button class="btn btn-secondary btn-short" @click="editorTag" id="save">Save</button>
          </div>
        </div>
      </b-modal>
      <div class="clearfix"></div>
    </div><acfooter></acfooter>
  </div>
</template>
<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import poolsidebar from "../../layout/Pool/Sidebar.vue"
 
  export default {
    name: 'PoolTags',
    components: { acheader, acfooter, poolsidebar },
    data() {
      return {
        IsAdmin: false,
        newTag: null,
        possibleTags: null,
        editTag: null,
        TagID: null,
        search: ""
      }
    },
    methods: {
      filteredList() {
        return this.possibleTags.filter((possibletag) =>
          possibletag.TagName.toLowerCase().includes(this.search.toLowerCase())
        );
      },
      addTag() {
        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "AddTag",
            Fields: {
              LicensePoolID: this.sdata.activepool.LicensePoolID,
              TagName: this.newTag
            }
          }
        ]).then(r => {
          this.popDialog(0, "Tag Added Successfully");
          this.render();
        });
      },
      goBack() {
        this.$router.back();
      },
     removeTag(tagID) {
        this.$bvModal.msgBoxConfirm('Are you sure you want to delete this tag?', {
          title: 'Confirm Deletion',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Delete',
          cancelTitle: 'Cancel',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
          modalClass:"remove_item_model"
        }).then(value => {
          if (value) {
            this.apiCommand([
              {
                Operation: "LicensePool",
                Function: "DeleteTag",
                Fields: {
                  LicensePoolID: this.sdata.activepool.LicensePoolID,
                  LicensePoolTagID: tagID
                }
              }
            ]).then(r => {
              this.popDialog(0, "Tag Removed Successfully");
              this.render();
            })
          }
        });
        setTimeout("Window.loadLanguageContent()", 500);
      },
      editorTag() {
        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "EditTag",
            Fields: {
              LicensePoolID: this.sdata.activepool.LicensePoolID,
              LicensePoolTagID: this.TagID,
              LicensePoolTagName: this.editTag
            }
          }
        ]).then(r => {
          this.popDialog(0, "Tag Edited Successfully");
          this.$refs["editorModel"].hide();
          this.render();
        });
      },
      openPopup(tagID, tagName) {
        this.TagID = tagID;
        this.editTag = tagName;
        this.$refs["editorModel"].show();
        Window.loadLanguageContent();
      },
      render() {
        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetTags",
            Fields: {
              LicensePoolID: this.sdata.activepool.LicensePoolID
            }
          }
        ]).then(r => {
          var cr = JSON.parse(r.CommandResult);
          this.possibleTags = JSON.parse(cr.returnObjects[0].returnObject);

        });
      }
    },
    mounted() {
      this.doPage().then(r => {
        this.bootstrapPool(this.$route.params.id);
        this.IsAdmin = this.sdata.activepool.IsAdmin;
        this.render();
        setTimeout("Window.loadLanguageContent()", 500);
      });
    }
  }
</script>
